import { render, staticRenderFns } from "./Bio.vue?vue&type=template&id=285d6dac&scoped=true&"
import script from "./Bio.vue?vue&type=script&lang=js&"
export * from "./Bio.vue?vue&type=script&lang=js&"
import style0 from "./Bio.vue?vue&type=style&index=0&id=285d6dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285d6dac",
  null
  
)

export default component.exports